const semanticClassNames = {
  root: 'section',
} as const;

export default semanticClassNames;
